module.exports = "<style type='text/css'>\n  {{styling}}\n</style>\n"